import { CommonModule, KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  computed,
  inject
} from '@angular/core';
import { RadiosComponent, RadioNode } from '@jeppesen-foreflight/jmkw-toolkit';
import {
  ExtendedMap,
  measurementArrays,
  METRIC_DEFAULT,
  IMPERIAL_DEFAULT,
  JmkwUnitConfigKey
} from '@jeppesen-foreflight/jmkw-types';
import { JmkwApiService } from '@jeppesen-foreflight/jmkw-core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: ' test-core-unit-config-popout',
  templateUrl: './unit-config.popout.component.html',
  styleUrls: ['./unit-config.popout.comonent.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RadiosComponent],
  standalone: true
})
export class UnitConfigPopoutComponent {
  private readonly _api = inject(JmkwApiService);

  radioNodeMap: Signal<ExtendedMap<ExtendedMap<RadioNode>>> = computed(() => {
    return this.convertUnitConfigTypestoRadioNodeMap();
  });

  measurementNodeMap: ExtendedMap<RadioNode> =
    this.convertMeasurementSystemToRadioNodeMap();

  convertUnitConfigTypestoRadioNodeMap() {
    const radioMap = new ExtendedMap<ExtendedMap<RadioNode>>();
    const unitConfigs = this._api.getUnitConfig();
    Object.keys(unitConfigs).forEach((key) => {
      if (key !== 'measurementSystem') {
        const tempRadioNode = new ExtendedMap<RadioNode>();
        measurementArrays.get(key)?.forEach((measurementValue) => {
          tempRadioNode.set(
            measurementValue,
            new RadioNode({
              id: measurementValue,
              label:
                measurementValue.charAt(0).toUpperCase() +
                measurementValue.slice(1).toLowerCase().replace('_', ' '),
              parent: key
            })
          );
        });
        radioMap.set(key, tempRadioNode);
      }
    });
    return radioMap;
  }

  convertMeasurementSystemToRadioNodeMap() {
    const radioMap = new ExtendedMap<RadioNode>();
    measurementArrays.get('measurementSystem')?.forEach((measurementValue) => {
      radioMap.set(
        measurementValue,
        new RadioNode({
          id: measurementValue,
          label:
            measurementValue.charAt(0).toUpperCase() +
            measurementValue.slice(1).toLowerCase().replace('_', ' ')
        })
      );
    });
    return radioMap;
  }

  radioChangeHandler({ key, value }: KeyValue<string, RadioNode>) {
    if (key === 'METRIC') this._api.setUnitConfig(METRIC_DEFAULT);
    else if (key === 'IMPERIAL') this._api.setUnitConfig(IMPERIAL_DEFAULT);
    else {
      this._api.setUnit(value.parent as JmkwUnitConfigKey, key);
    }
  }

  selectedId(key: string) {
    const unitConfig = this._api.getUnitConfig();
    return unitConfig[key as JmkwUnitConfigKey];
  }

  formatName(name: string) {
    return (
      name.charAt(0).toUpperCase() +
      name
        .slice(1)
        .replace(/([A-Z])/g, ' $1')
        .trim()
    );
  }
}
